import { render, staticRenderFns } from "./table-row-skeleton.vue?vue&type=template&id=610f9a6d&"
import script from "./table-row-skeleton.component.ts?vue&type=script&lang=ts&"
export * from "./table-row-skeleton.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports